// This file is generated automatically by scripts/generate-flag.js. Don't modify it.
import React from 'react';
import SaudiArabia from '../_raw/flag/icon_flag_saudi_arabia.png';

export default () => <img src={SaudiArabia} alt="SaudiArabia" />;
